<template>
  <div>
    <v-layout justify-left wrap ma-3>
      <v-flex xs2>
        <v-text-field
          v-if="process"
          label="Process Name"
          v-model="process.name"
        ></v-text-field>
        <v-btn round color="primary" class="white--text" @click="exportData()"
          >Save</v-btn
        >
        <v-divider></v-divider>

        <v-layout justify-left align-center class="text-xs-left">
          <v-flex xs3>
            <v-icon>events</v-icon>
          </v-flex>
          <v-flex xs9>
            <h3 class="grey--text">Event</h3>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>

        <v-list>
          <v-list-tile
            @click=""
            style="cursor: pointer"
            class="drag-drawflow"
            draggable="true"
            v-on:dragstart="drag"
            :data-node="JSON.stringify(item)"
            v-for="item in events"
            :key="item.name"
          >
            <v-list-tile-action
              ><v-icon>drag_indicator</v-icon></v-list-tile-action
            >
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-layout justify-left align-center class="text-xs-left">
          <v-flex xs3>
            <v-icon>list_alt</v-icon>
          </v-flex>
          <v-flex xs9>
            <h3 class="grey--text">Forms</h3>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>

        <v-list>
          <v-list-tile
            @click=""
            style="cursor: pointer"
            class="drag-drawflow"
            draggable="true"
            v-on:dragstart="drag"
            :data-node="JSON.stringify(form)"
            v-for="form in forms"
            :key="form.id"
          >
            <v-list-tile-action
              ><v-icon>drag_indicator</v-icon></v-list-tile-action
            >
            <v-list-tile-title>{{ form.name }}</v-list-tile-title>
            <!-- <v-list-tile-action><v-icon>drag_indicator</v-icon></v-list-tile-action> -->
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>

        <v-layout justify-left align-center class="text-xs-left">
          <v-flex xs3>
            <v-icon>functions</v-icon>
          </v-flex>
          <v-flex xs9>
            <h3 class="grey--text">Functions</h3>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>

        <v-list>
          <v-list-tile
            @click=""
            style="cursor: pointer"
            class="drag-drawflow"
            draggable="true"
            v-on:dragstart="drag"
            :data-node="JSON.stringify(item)"
            v-for="item in functions"
            :key="item.name"
          >
            <v-list-tile-action
              ><v-icon>drag_indicator</v-icon></v-list-tile-action
            >
            <v-list-tile-title>
              {{ item.name }}
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small class="mr-2">help</v-icon>
                </template>
                <span>{{ item.description }}</span>
              </v-tooltip></v-list-tile-title
            >
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>
        <v-layout justify-left align-center class="text-xs-left">
          <v-flex xs3>
            <v-icon>storage</v-icon>
          </v-flex>
          <v-flex xs9>
            <h3 class="grey--text">Models</h3>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>

        <v-list>
          <v-list-tile
            @click=""
            style="cursor: pointer"
            class="drag-drawflow"
            draggable="true"
            v-on:dragstart="drag"
            :data-node="JSON.stringify(model)"
            v-for="model in sharedModels"
            :key="model.id"
          >
            <v-list-tile-action
              ><v-icon>drag_indicator</v-icon></v-list-tile-action
            >
            <v-list-tile-title
              >{{ model.name }}
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small class="mr-2">help</v-icon>
                </template>
                <span>{{ model.description }}</span>
              </v-tooltip>
            </v-list-tile-title>
            <!-- <v-list-tile-action><v-icon>drag_indicator</v-icon></v-list-tile-action> -->
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>
        <v-layout justify-left align-center class="text-xs-left">
          <v-flex xs3>
            <v-icon>confirmation_number</v-icon>
          </v-flex>
          <v-flex xs9>
            <h3 class="grey--text">Tickets</h3>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-list>
          <v-list-group
            @click.stop
            v-for="category in ticketCategories"
            :key="category.id"
            :prepend-icon="category.icon"
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{ category.name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            <v-list>
              <v-list-tile
                @click=""
                style="cursor: pointer"
                class="drag-drawflow"
                draggable="true"
                v-on:dragstart="drag"
                :data-node="JSON.stringify(ticket)"
                v-for="ticket in category.ticketCategoryItems"
                :key="ticket.name"
              >
                <v-list-tile-action
                  ><v-icon>drag_indicator</v-icon></v-list-tile-action
                >
                <v-list-tile-title>{{ ticket.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-list-group>
        </v-list>
      </v-flex>
      <v-flex xs7>
        <div id="drawflow" v-on:drop="drop" v-on:dragover="allowDrop"></div>
      </v-flex>
      <v-flex xs3>
        <v-card flat color="white">
          <v-toolbar flat color="primary" text-xs-center>
            <h3 class="title white--text text-xs-center">
              Editor
              <span v-if="selectedNode">
                | <i>{{ selectedNode.name }}</i>
              </span>
            </h3>
          </v-toolbar>
          <v-tabs dense grow>
            <v-tab @click="nodeViewTab = 'data'">Data</v-tab>
            <v-tab @click="nodeViewTab = 'condition'">Processing</v-tab>
          </v-tabs>
          <v-card-text v-if="!selectedNode">
            <span class="grey--text">Select a node to view details.</span>
          </v-card-text>
          <v-card-text v-else style="overflow-y: auto; max-height: 720px">
            <div v-if="nodeViewTab == 'data'">
              <v-layout
                justify-left
                align-center
                wrap
                class="text-xs-left"
                mt-1
              >
                <v-flex xs12>
                  <h4 class="grey--text">
                    Type:
                    <span class="font-weight-light">{{
                      selectedNode.data.type.split("_")[0]
                    }}</span>
                  </h4>
                </v-flex>
                
                <v-flex xs12>
                  <i class="grey--text">{{ selectedNode.data.description }}</i>
                </v-flex>
                <v-flex
                  xs12
                  v-if="selectedNode.data.type.split('_')[0] == 'model'"
                >
                  <v-select
                    :items="databaseFunctions"
                    item-text="name"
                    item-value="functionType"
                    label="Applied Function"
                    v-model="selectedNode.function"
                    @change="exportData()"
                  ></v-select>
                </v-flex>

                <v-flex xs12>
                  <v-divider></v-divider>
                  <v-layout align-center>
                    <!-- <v-icon color="primary" @click="addNodeInput(selectedNode.id)">add_circle_outline</v-icon> -->
                    <h4 class="grey--text">
                      Inputs

                      <v-chip small>{{
                        Object.keys(selectedNode.inputs).length
                      }}</v-chip>
                    </h4>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-if="Object.keys(selectedNode.inputs).length > 0">
                  <v-list>
                    <v-list-group
                      @click.stop
                      v-for="input in Object.keys(selectedNode.inputs)"
                      :key="input"
                      no-action
                    >
                      <template v-slot:activator>
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-icon
                              color="red"
                              @click="removeNodeInput(selectedNode.id, input)"
                              >remove_circle_outline</v-icon
                            >
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <h4 class="grey--text font-weight-light ml-1">
                              {{ input }}
                            </h4>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                      <v-list>
                        <v-list-tile
                          @click=""
                          style="cursor: pointer"
                          v-for="connection in selectedNode.inputs[input]
                            .connections"
                          :key="connection.node"
                        >
                          <h5 class="grey--text font-weight-light ml-3">
                            {{
                              editor.getNodeFromId(connection.node).data.name
                            }}
                          </h5>
                        </v-list-tile>
                      </v-list>
                    </v-list-group>
                  </v-list>

                  <v-divider></v-divider>
                </v-flex>

                <v-flex xs12>
                  <v-layout align-center>
                    <!-- <v-icon color="primary"  @click="addNodeOutput(selectedNode.id)">add_circle_outline</v-icon> -->
                    <h4 class="grey--text">
                      Outputs

                      <v-chip small>{{
                        Object.keys(selectedNode.outputs).length
                      }}</v-chip>
                    </h4>
                  </v-layout>
                </v-flex>

                <v-flex
                  xs12
                  v-if="Object.keys(selectedNode.outputs).length > 0"
                >
                  <v-list>
                    <v-list-group
                      @click.stop
                      v-for="output in Object.keys(selectedNode.outputs)"
                      :key="output"
                      no-action
                    >
                      <template v-slot:activator>
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-icon
                              color="red"
                              @click="removeNodeOutput(selectedNode.id, output)"
                              >remove_circle_outline</v-icon
                            >
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <h4 class="grey--text font-weight-light ml-1">
                              {{ output }}
                            </h4>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                      <v-list>
                        <v-list-tile
                          @click=""
                          style="cursor: pointer"
                          v-for="connection in selectedNode.outputs[output]
                            .connections"
                          :key="connection.node"
                        >
                          <h5 class="grey--text font-weight-light ml-3">
                            {{
                              editor.getNodeFromId(connection.node).data.name
                            }}
                          </h5>
                        </v-list-tile>
                      </v-list>
                    </v-list-group>
                  </v-list>
                  <v-divider></v-divider>
                </v-flex>

                <v-flex
                  xs12
                  v-if="
                    selectedNode.data &&
                    (selectedNode.data.data)
                  "
                >
                  <h4 class="grey--text">Attributes</h4>
                </v-flex>

                <v-flex
                  xs12
                  v-if="
                    selectedNode.data &&
                      selectedNode.data.data
                  "
                >
                  <v-card flat>
                    <vue-json-pretty
                      :path="'res'"
                      :data="selectedNode.data.data"
                    >
                    </vue-json-pretty>
                  </v-card>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
            </div>
            <div v-if="nodeViewTab == 'condition'">
              <v-flex xs12>
                <h4 class="grey--text">
                  Outputs
                  <v-chip>{{
                    Object.keys(selectedNode.outputs).length
                  }}</v-chip>
                </h4>
              </v-flex>

              <v-flex xs12>
                <v-card
                  flat
                  v-for="output in Object.keys(selectedNode.outputs)"
                  :key="output"
                >
                  <v-layout justify-left align-center wrap>
                    <v-flex xs6>
                      <h4
                        class="text-xs-left grey--text font-weight-light ml-1"
                      >
                        {{ output }}
                      </h4>
                    </v-flex>
                    <v-flex xs6>
                      <v-chip>{{selectedNode.outputs[output].condition}}</v-chip>
                    </v-flex>
                  </v-layout>
                </v-card>
                <v-divider></v-divider>
              </v-flex>
               <v-flex xs12 v-if="selectedNode.data.type.split('_')[0] == 'model'&&selectedNode.inputs.input_1">
                <h4 class="grey--text">
                  Data Mapping
                </h4>
              </v-flex>

              <v-flex xs12 v-if="selectedNode.data.type.split('_')[0] == 'model'&&selectedNode.inputs.input_1">
                <v-card
                  flat
                  v-for="input in selectedNode.data.data "
                  :key="input"
                >
                  <v-layout justify-left align-center wrap>
                    <v-flex xs6>
                      <h4
                        class="text-xs-left grey--text font-weight-light ml-1"
                      >
                        {{ input.name }}
                      </h4>
                    </v-flex>
                    <v-flex xs6>
                      <v-select label="Database Value" :items="editor.getNodeFromId(selectedNode.inputs.input_1.connections[0].node).data.data" item-text="field" item-value="field" v-model="selectedNode.mappedData[input.value]"></v-select>
                    </v-flex>
                  </v-layout>
                </v-card>
                <v-divider></v-divider>
              </v-flex>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="newNodeOptionsModal" width="300px">
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="white--text">Node Settings</h3>
        </v-toolbar>
        <v-card-text>
          <v-select
            label="Inputs"
            :items="[0, 1, 2, 3, 4, 5, 6, 7, 8]"
            v-model="newNode.inputs"
          ></v-select>
          <v-select
            label="Outputs"
            :items="[0, 1, 2, 3, 4, 5, 6, 7, 8]"
            v-model="newNode.outputs"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              color="primary"
              class="white--text"
              round
              @click="addNodeToDrawFlow()"
              >Save</v-btn
            >
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";
import event from "@/services/Event";
import Vue from "vue";
/*eslint-disable */
import NodeClick from "./NodeClick.vue";
import Drawflow from "drawflow";
import styleDrawflow from "drawflow/dist/drawflow.min.css"; // eslint-disable-line no-use-before-define
/*eslint-enable */
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
  components: {
    VueJsonPretty,
  },
  name: "App",
  data() {
    return {
      editor: null,
      forms: [],
      events: [
        { id: 1, type: "event_1", name: "Start", functionType: "start" },
        { id: 2, type: "event_2", name: "Finish", functionType: "end" },
        { id: 3, type: "event_3", name: "New Order", functionType: "event" },
      ],
      databaseFunctions: [
        {
          name: "Create",
          functionType: "create",
          description: "Creates a database entry for the selected model.",
        },
        {
          name: "Update",
          functionType: "update",
          description: "Updates the database entry for the selected model.",
        },
        {
          name: "Delete",
          functionType: "delete",
          description: "Deletes the database entry for the selected model.",
        },
      ],
      functions: [
        {
          id: 1,
          type: "function_1",
          name: "Provision Device",
          functionType: "provision",
          description: "Configures the layer 2 connection for the device.",
        },
      ],
      nodeViewTab: "data",
      process: {},
      processes: [],
      sharedModels: [],
      selectedNode: null,
      ticketCategories: [],
      newNode: {},
      newNodeOptionsModal: false,
    };
  },
  created() {
    this.initialize();
  },
  mounted() {
    const id = document.getElementById("drawflow");
    this.editor = new Drawflow(id, Vue);
    this.editor.reroute = true;
    this.editor.start();
    this.editor.clear();
    this.editor.zoom_out();
    this.editor.zoom_out();
    this.editor.zoom_out();

    this.editor.on("nodeSelected", (id) => {
      this.selectedNode = this.editor.getNodeFromId(id);
    });
    this.editor.on('nodeCreated', async (id)=>{
      this.selectedNode = this.editor.getNodeFromId(id)
      let type = this.selectedNode.data.type.split('_')[0]
      if(this.selectedNode.outputs.output_1){
        if (type == "form") {
        this.selectedNode.outputs.output_1.condition = 'Form Completed'
        this.selectedNode.outputs.output_2.condition = 'Form Incomplete'
      } else if (type == "ticket") {
        this.selectedNode.outputs.output_1.condition = 'Complete'
        this.selectedNode.outputs.output_2.condition = 'Incomplete'
        this.selectedNode.outputs.output_3.condition = 'Cancelled'
      } else if (type == "model") {
        this.selectedNode.outputs.output_1.condition = 'Success'
        this.selectedNode.outputs.output_2.condition = 'Failure'
      } else if (type == "function") {
        this.selectedNode.outputs.output_1.condition = 'Success'
        this.selectedNode.outputs.output_2.condition = 'Failure'
      } else if (type == "event") {
        this.selectedNode.outputs.output_1.condition = 'Success'
      }
      }
      this.selectedNode.mappedData = {}
      
      await this.exportData()
      this.fetchProcesses()
    })
    this.editor.on("connectionCreated", (info) => {
      console.log(info);
      const nodeInfo = this.editor.getNodeFromId(info.input_id);
      console.log(nodeInfo);
      if (
        nodeInfo.name.split("_")[0] != "Start" &&
        nodeInfo.name.split("_")[0] != "Finish" &&
        nodeInfo.inputs[info.input_class].connections.length > 1
      ) {
        const removeConnectionInfo =
          nodeInfo.inputs[info.input_class].connections[0];
        this.editor.removeSingleConnection(
          removeConnectionInfo.node,
          info.input_id,
          removeConnectionInfo.input,
          info.input_class
        );
      }
    });
    event.$on("updateConnector", (id) => {
      console.log("Update ", id);
      setTimeout(() => {
        this.editor.updateConnectionNodes(id);
      }, 20);
    });
    event.$on("selectNode", (id) => {
      this.selectedNode = this.editor.getNodeFromId(id.slice(5));
    });

    const props = {};
    const options = {};
    for (let i = 0; i < this.events.length; i++) {
      this.editor.registerNode(
        "event_" + this.events[i].id,
        NodeClick,
        { type: "event", name: this.events[i].name },
        options
      );
    }
    for (let i = 0; i < this.functions.length; i++) {
      this.editor.registerNode(
        "function_" + this.functions[i].id,
        NodeClick,
        {
          type: "function",
          name: this.functions[i].name,
          description: this.functions[i].description,
        },
        options
      );
    }
  },
  methods: {
    async initialize() {
      await this.fetchForms();
      await this.fetchTicketCategoryItems();
      await this.fetchSharedModels();
      this.fetchProcesses();
    },
    async fetchProcesses() {
      await Api()
        .get("/workflows/processes/" + this.$route.params.processId)
        .then((res) => {
          this.process = res.data;
          this.process.data = JSON.parse(this.process.data);
          if(this.process.data){
          this.editor.import(this.process.data);

          }
        });
    },
    async fetchForms() {
      await Api()
        .get("/forms")
        .then((res) => {
          this.forms = res.data;
          this.forms.forEach((x) => (x.type = "form_" + x.id));
          for (let i = 0; i < this.forms.length; i++) {
            this.forms[i].data = JSON.parse(this.forms[i].data);
            this.editor.registerNode(
              "form_" + this.forms[i].id,
              NodeClick,
              {
                type: "form",
                name: this.forms[i].name,
                data: this.forms[i].data,
              },
              {}
            );
          }
        });
    },
    async fetchSharedModels() {
      await Api()
        .get("/workflow/list/sharedModels")
        .then(async (res) => {
          this.sharedModels = res.data;
          for (let i = 0; i < this.sharedModels.length; i++) {
            this.sharedModels[i].type = "model_" + this.sharedModels[i].id;
            
            this.sharedModels[i].data= this.sharedModels[i].workflowModelSharedAttributes.map(
              (x) => ({
                name: x.name,
                description: x.description,
                value: x.value
              })
            );
            console.log('Type',this.sharedModels[i].type)

            this.editor.registerNode(
              "model_" + this.sharedModels[i].id,
              NodeClick,
              {
                type: "model",
                name: this.sharedModels[i].name,
                description: this.sharedModels[i].description,
                data: this.sharedModels[i].data
              },
              {}
            );
          }
        });
    },
    async fetchTicketCategoryItems() {
      await Api()
        .get("/ticketCategory")
        .then((res) => {
          this.ticketCategories = res.data;
          this.ticketCategories.forEach((x) =>
            x.ticketCategoryItems.forEach((y) => (y.type = "ticket_" + y.id))
          );
          for (let i = 0; i < this.ticketCategories.length; i++) {
            for (
              let j = 0;
              j < this.ticketCategories[i].ticketCategoryItems.length;
              j++
            ) {
              this.editor.registerNode(
                "ticket_" + this.ticketCategories[i].ticketCategoryItems[j].id,
                NodeClick,
                {
                  type: "ticket",
                  name: this.ticketCategories[i].ticketCategoryItems[j].name,
                },
                {}
              );
            }
          }
          console.log(this.ticketCategories);
        });
    },
    allowDrop(ev) {
      ev.preventDefault();
    },
    drag(ev) {
      ev.dataTransfer.setData("node", ev.target.getAttribute("data-node"));
    },
    drop(ev) {
      ev.preventDefault();
      var data = ev.dataTransfer.getData("node");
      this.newNode = {
        inputs: 0,
        outputs: 0,
        data: JSON.parse(data),
        x_pos: ev.clientX-250,
        y_pos: ev.clientY-250,
      };
      this.addNodeToDrawFlow();
    },
    setOutputs(type) {
      let result = 0;
      if (type == "form") {
        result = 2;
      } else if (type == "ticket") {
        result = 3;
      } else if (type == "model") {
        result = 2;
      } else if (type == "function") {
        result = 2;
      } else if (type == "event") {
        result = 1;
      }
      return result;
    },
    addNodeToDrawFlow() {
      let currentData = this.editor.export();
      console.log(currentData)
      let newIndex = currentData?(Object.keys(currentData.drawflow.Home.data).length += 1):1;
      this.newNodeOptionsModal = false;
      this.editor.addNode(
        this.newNode.data.name + "_" + newIndex,
        this.newNode.data.name == "Start" ? 0 : 1,
        this.newNode.data.name == "Finish"
          ? 0
          : this.setOutputs(this.newNode.data.type.split("_")[0]),
        this.newNode.x_pos,
        this.newNode.y_pos,
        this.newNode.data.name == "Start"||this.newNode.data.name == "Finish"?"event":"multiple",
        this.newNode.data,
        this.newNode.data.type,
        "vue"
      );
    },
    async addNodeOutput(id) {
      await this.editor.addNodeOutput(id);
      this.selectedNode = this.editor.getNodeFromId(id);
    },
    async addNodeInput(id) {
      await this.editor.addNodeInput(id);
      this.selectedNode = this.editor.getNodeFromId(id);
    },
    async removeNodeOutput(id, output) {
      await this.editor.removeNodeOutput(id, output);
      this.selectedNode = this.editor.getNodeFromId(id);
    },
    async removeNodeInput(id, input) {
      await this.editor.removeNodeInput(id, input);
      this.selectedNode = this.editor.getNodeFromId(id);
    },
    async exportData() {
      let data = this.editor.export();
      console.log(data);
      if (this.selectedNode) {
        if(data.drawflow.Home.data[this.selectedNode.id]){
        data.drawflow.Home.data[this.selectedNode.id] = this.selectedNode;

        }
      }
      await Api().put("/workflows/processes/" + this.process.id, {
        name: this.process.name,
        data: JSON.stringify(data),
      });
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#drawflow {
  text-align: initial;
  width: 100%;
  height: 90vh;
  border: 1px solid rgb(131, 131, 131);
  background-size: 10px 10px;
  background-image: linear-gradient(
      to right,
      rgb(231, 231, 231) 1px,
      transparent 1px
    ),
    linear-gradient(to bottom, rgb(190, 190, 190), transparent 1px);
  background-repeat: repeat;
}
.drawflow-node.multiple .outputs .output {
  background: #898a89;
}

.drawflow,
.drawflow .parent-node {
    position: relative
}

.parent-drawflow {
    display: flex;
    overflow: hidden;
    touch-action: none;
    outline: 0
}

.drawflow {
    width: 100%;
    height: 100%;
    user-select: none
}

.drawflow .drawflow-node {
    display: flex;
    align-items: center;
    position: absolute;
    background: rgb(255, 255, 255);
    width: auto;
    min-height: 40px;
    border-radius: 10px;
    border: 2px solid #8b8b8b;
    color: #000;
    z-index: 2;
    padding: 15px
}

.drawflow .drawflow-node.selected {
    background: rgb(255, 255, 255);
    border: 2px solid #979899;
    box-shadow: 0px 2px 15px 2px #4ea9ff;
}

.drawflow .drawflow-node:hover {
    cursor: move
}

.drawflow .drawflow-node .inputs,
.drawflow .drawflow-node .outputs {
    width: 0
}

.drawflow .drawflow-node .drawflow_content_node {
    width: 100%;
    display: block
}

.drawflow .drawflow-node .input,
.drawflow .drawflow-node .output {
    position: relative;
    width: 20px;
    height: 20px;
    background: #fff;
    border-radius: 50%;
    border: 1px solid #8b8b8b;
    cursor: crosshair;
    z-index: 1;
    margin-bottom: 5px
}

.drawflow .drawflow-node .input {
    left: -27px;
    top: 2px;
    background: rgb(89, 152, 204)
}

.drawflow .drawflow-node .output {
    right: -3px;
    top: 2px;
}
.drawflow-node.event {
  width: 175px;
  height: 175px;
  line-height: 100px;
  border-radius: 50%;
  font-size: 25px;
  color: #fff;
  text-align: center;
  background: #ffffff;
    border: 2px solid #16b811;
}
.drawflow-node.multiple .outputs .output:nth-child(2) {
  background: #d81c16;
}
.drawflow-node.multiple .outputs .output:nth-child(3) {
  background: #f16609;
}

.drawflow-node.multiple .outputs .output:nth-child(2) .output:nth-child(1) {
    right: -3px;
    top: 2px;
    background: rgb(60, 190, 99)
}

.drawflow svg {
    z-index: 0;
    position: absolute;
    overflow: visible!important
}

.drawflow .connection {
    position: absolute;
    transform: translate(9999px, 9999px)
}

.drawflow .connection .main-path {
    fill: none;
    stroke-width: 2px;
    stroke: #8b8b8b;
    transform: translate(-9999px, -9999px)
}

.drawflow .connection .main-path:hover {
    stroke: #6cb8d6;
    cursor: pointer
}

.drawflow .connection .main-path.selected {
    stroke: #43b993
}

.drawflow .connection .point {
    cursor: move;
    stroke: #000;
    stroke-width: 2;
    fill: rgb(250, 248, 248);
    transform: translate(-9999px, -9999px)
}

.drawflow .connection .point.selected,
.drawflow .connection .point:hover {
    fill: #1266ab
}

.drawflow .main-path {
    fill: none;
    stroke-width: 5px;
    stroke: #4682b4
}

.drawflow .selectbox {
    z-index: 3;
    position: absolute;
    transform: translate(9999px, 9999px)
}

.drawflow .selectbox rect {
    fill: #00f;
    opacity: .5;
    stroke: #ff0;
    stroke-width: 5;
    stroke-opacity: .5;
    transform: translate(-9999px, -9999px)
}

.drawflow-delete {
    position: absolute;
    display: block;
    width: 30px;
    height: 30px;
    background: #eb2603;
    color: #fff;
    z-index: 4;
    border: 2px solid #fff;
    line-height: 30px;
    font-weight: 700;
    text-align: center;
    border-radius: 50%;
    font-family: monospace;
    cursor: pointer
}

.drawflow>.drawflow-delete {
    margin-left: -10px;
    margin-top: 10px
}

.parent-node .drawflow-delete {
    right: -15px;
    top: -15px
}
</style>